import _extends from "@babel/runtime/helpers/extends";
import React, { useCallback, useEffect, useState } from "react";
import ReactDOM from 'react-dom';
import Viewer from "react-viewer";
import "./index.scss";
var ins = null;
var show = function show(option) {
  if (option === void 0) {
    option = {};
  }
  if (!ins) {
    var oDiv = document.createElement('div');
    oDiv.className = 'ImageViewerRoot';
    document.body.appendChild(oDiv);
    ReactDOM.render( /*#__PURE__*/React.createElement(ImageViewer, null), oDiv);
    ins = oDiv;
  }
  setTimeout(function () {
    var ev = new CustomEvent('showImageViewer');
    ev.data = option;
    window.dispatchEvent(ev);
  }, 30);
  return {
    hide: function hide() {
      ins = null;
      window.dispatchEvent(new Event('hideImageViewer'));
    }
  };
};
var ImageViewer = function ImageViewer(props) {
  var _useState = useState(false),
    visible = _useState[0],
    setVisible = _useState[1];
  var _useState2 = useState({}),
    option = _useState2[0],
    setOption = _useState2[1];
  var newProps = _extends({}, props, option);
  useEffect(function () {
    var showImageViewer = function showImageViewer(e) {
      var newOption = e.data || {};
      setVisible(true);
      setOption(newOption);
    };
    var hideImageViewer = function hideImageViewer() {
      setVisible(false);
    };
    window.addEventListener('showImageViewer', showImageViewer);
    window.addEventListener('hideImageViewer', hideImageViewer);
    return function () {
      window.removeEventListener('showImageViewer', showImageViewer);
      window.removeEventListener('hideImageViewer', hideImageViewer);
    };
  }, []);
  var onClose = useCallback(function () {
    setVisible(false);
    newProps === null || newProps === void 0 ? void 0 : newProps.onClose();
  }, [newProps]);
  return /*#__PURE__*/React.createElement(Viewer, _extends({
    visible: visible
  }, newProps, {
    onClose: onClose
  }));
};
export { show };
export default ImageViewer;